import { LanguageTwoTone } from '@mui/icons-material';
import { Trans, useTranslation } from '@sortlist-frontend/translation/ssr';
import { Fragment, useState } from 'react';

import { usePublicAppContext } from '_core/context/public-app-context';
import { agencyProfileConfig } from '_features/AgencyProfile/config';
import { useGetAgencyProfile } from '_features/AgencyProfile/hooks/useGetAgencyProfile';

import { getLanguagesFromCodes, LANGUAGES_MIN_LENGTH } from './utils';

export const Languages = () => {
  const [isToggledLanguages, setToggledLanguages] = useState(false);
  const { t } = useTranslation(agencyProfileConfig.i18nNamespaces);
  const { locale, pageData } = usePublicAppContext();
  const { agencySlug } = pageData as { agencySlug: string };
  const { data: { agency } = {} } = useGetAgencyProfile({ agencySlug, locale: locale as string });
  const languages = agency?.languages ?? [];

  return (
    <div className="flex-50 flex-xs-100 layout-row layout-align-start-center">
      <LanguageTwoTone style={{ fontSize: 16 }} className="m-2 text-secondary-500" />
      <span className="m-2 small text-break-word">
        <Trans
          i18nKey={'agency:profile.about.details.speakLanguages'}
          values={{ languages: getLanguagesFromCodes(languages, locale as string, isToggledLanguages) }}>
          Speaks
          <b className="text-capitalize">{'{{languages}}'}</b>
        </Trans>
        {languages.length > LANGUAGES_MIN_LENGTH && !isToggledLanguages ? (
          <Fragment>
            &nbsp;
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
            <a className="cursor-pointer underline text-secondary-900" onClick={() => setToggledLanguages(true)}>
              {t('common:clampLines.seeMore')}
            </a>
          </Fragment>
        ) : null}
      </span>
    </div>
  );
};
